import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Footer() {
  return (
    <footer className="tc-footer">
      <div className="container">
        <div className="text-center pt-60">
          <LazyLoadImage
            src="/home_borin/assets/images/footerBorin.webp"
            alt="Imagem da Borin"
            effect="blur"
            width={"auto"}
            height={"100%"}
          />

          <p className="fsz-12 pt-50 text-center color-gray">
            Ao enviar o formulário, você concorda com a nossa Política de
            Privacidade. Seus dados serão mantidos em sigilo na nossa empresa e
            você poderá revogar essa autorização a qualquer momento, basta
            clicar no botão de descadastro ao receber um e-mail.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
